/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2021-04-01 13:44:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-05-11 17:06:15
 */
import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setCookie(key, token) {
  return Cookies.set(key, token)
}
export function getCookie(key) {
  return Cookies.get(key)
}
